import type { MapBounds } from '../types';
import type { InteractiveMapItem } from '@skyscanner-internal/landing-pages-shared-types/types-shared/InteractiveMapProps';

/**
 * Get the bounds of the map based on the items
 * @param {InteractiveMapItem} items - The items to calculate the bounds from
 * @returns {MapBounds | null} - The bounds of the map or null if there are less than two items
 */
const getBounds = (items: InteractiveMapItem[]): MapBounds | null => {
  if (items.length < 2) {
    return null;
  }
  const lats = items.map((item) => item.mapMarker.lat).sort((a, b) => a - b);
  const lons = items.map((item) => item.mapMarker.lng).sort((a, b) => a - b);

  const bounds = {
    south: lats[0],
    west: lons[0],
    north: lats[lats.length - 1],
    east: lons[lons.length - 1],
  };
  return bounds;
};

export default getBounds;
